import type { LucideIcon } from 'lucide-react';
import { Bomb, GitBranch, Tags } from 'lucide-react';

import { ArtifactType } from './artifact-type.models';

export interface ArtifactTypeMetadata {
  /**
   * Short display label for the Artifact Type (e.g., "Image", "SBOM")
   */
  label: string;
  /**
   * Long-form title for the Artifact Type (e.g., "Container Image").
   * Falls back to `label` if not provided.
   */
  title?: string;
  /**
   * Icon name that will decorate the Artifact Type
   */
  icon: LucideIcon;
  /**
   * One-line description of what this artifact type represents. Used in
   * help/legend surfaces.
   */
  description: string;
}

export const artifactTypeMetadata: Record<ArtifactType, ArtifactTypeMetadata> =
  {
    [ArtifactType.Image]: {
      label: 'Image',
      title: 'Container Image',
      icon: Tags,
      description: 'A container image reference provided for analysis',
    },
    [ArtifactType.SBOM]: {
      label: 'SBOM',
      icon: Bomb,
      description: 'An uploaded SBOM document (CycloneDX, SPDX, or Syft)',
    },
    [ArtifactType.Source]: {
      label: 'Repository',
      title: 'Source Repository',
      icon: GitBranch,
      description: 'A source code repository tracked for analysis',
    },
  };

/**
 * Get metadata for an artifact type
 */
export const getArtifactTypeMetadata = (
  type: ArtifactType,
): ArtifactTypeMetadata => artifactTypeMetadata[type];
